/*
 * Emailed sign-in links that RMS owns (TDI-706 criterion 1).
 *
 * The sign-in email carries a one-time token that works for 24 hours:
 *   /rms/link-sign-in?orgId=...&t=<token>&continue=...
 * (family-portal links land on /rms/family/sign-in with the same query).
 * The landing page swaps the token for a Firebase custom token through
 * rmsRedeemSignInLink. Pure helpers, no lookups.
 */
import { rmsPathFromContinueUrl } from './signInRoutes';

export const LINK_SIGN_IN = '/rms/link-sign-in';

/**
 * The token, organisation and continue address an emailed link carries, or
 * null when the address has no token.
 */
export function readEmailedSignInLink(search) {
  const params = new URLSearchParams(search || '');
  const token = params.get('t');
  if (!token) return null;
  return {
    token,
    orgId: params.get('orgId') || '',
    continuePath: params.get('continue') || '',
  };
}

/**
 * The address to go to after signing in, when it is an /rms/ path on this
 * site; otherwise the fallback. Never another site, a scheme or '//host'.
 */
export function safeRmsContinuePath(path, fallback, origin) {
  if (typeof path !== 'string' || !path.startsWith('/')) return fallback;
  const url = rmsPathFromContinueUrl(path, origin);
  if (!url) return fallback;
  return `${url.pathname}${url.search}${url.hash}`;
}
